import _ from 'lodash';

import {
  QueryOrdersFilterInput,
  useSkuSwapWidgetLazyQuery
} from 'generated/graphql';

import { listQueryUtil } from 'iron-forge-react-modules';
import { DateTime } from 'luxon';
import * as types from './types';



const useListQuery = listQueryUtil.genUseListQuery<types.IColumnId>();

export interface IOrder {
  id: string;
  orderNumber: string;
  orderDate: DateTime;
}

export interface IData {
  orders: IOrder[];
}

export function useQuery() {
  return useListQuery({
    useLazyQuery: useSkuSwapWidgetLazyQuery,
    clientColumn2GqlSortField: {},
    initQuerySort: {
      columnId: 'orderDate',
      direction: 'descending'
    },
    defaultFilterArgs: {
    },
    gqlResultData2GqlPageInfo: gqlData => gqlData?.orders.pageInfo,
    gqlResultData2TupleData: (gqlTuple): IData => {
      return {
        orders: _.map(gqlTuple.data?.orders.nodes ?? [], (node): IOrder => ({
          id: node.id,
          orderNumber: node.orderNumber,
          orderDate: DateTime.fromISO(node.orderDate)
        }))
      };
    },
    genFilter2GqlFilter: () => __filter2GqlFilter
  });
}



function __filter2GqlFilter(filter?: {
  omniFreeText: string;
}): QueryOrdersFilterInput {
  return {
    hasUnresolvedSkuMismatches: true,
    omniFreeText: filter?.omniFreeText
  };
}
